const DESCRIPTION_DRAFT_PREFIX = 'kanbify:card-description-draft'

function draftKey(cardId, userId) {
    return `${DESCRIPTION_DRAFT_PREFIX}:${userId || 'anonymous'}:${cardId || 'unknown'}`
}

export function readDescriptionDraft(cardId, userId) {
    if (!cardId) return null
    try {
        const stored = window.localStorage.getItem(draftKey(cardId, userId))
        if (stored === null) return null
        const parsed = JSON.parse(stored)
        return typeof parsed?.value === 'string' ? parsed.value : null
    } catch {
        return null
    }
}

export function writeDescriptionDraft(cardId, userId, value) {
    if (!cardId) return
    try {
        window.localStorage.setItem(draftKey(cardId, userId), JSON.stringify({
            value,
            updatedAt: new Date().toISOString(),
        }))
    } catch { /* local storage can be unavailable in private/restricted contexts */ }
}

export function clearDescriptionDraft(cardId, userId) {
    if (!cardId) return
    try {
        window.localStorage.removeItem(draftKey(cardId, userId))
    } catch { /* best effort */ }
}
